export default [
    {
        path: '/settings/ai-prompt',
        props: true,
        component: () => import('@/views/AiPrompt'),
    },
];
